import { IJsonQuery } from '../json_query';

export const isNewobjectPage = (jsonQuery: IJsonQuery): boolean =>
  !!jsonQuery.geo && jsonQuery.geo.value.length === 1 && jsonQuery.geo.value[0].type === 'newobject';

export const isDeveloperPage = (jsonQuery: IJsonQuery): boolean =>
  !!jsonQuery.geo && jsonQuery.geo.value.length === 1 && jsonQuery.geo.value[0].type === 'builder';
